import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../Icon';
import { trackEvent } from '../../utils/analytics';
import { PHONE } from '../../content/contacts';
import { tie } from '../page/typography';

/**
 * Кінець сторінки «З чого почати» — один блок замість двох.
 *
 * Раніше під картками стояло речення «Якщо вашої ситуації тут немає,
 * подивіться часті запитання…», а одразу під ним — банер «Не знайшли своєї
 * ситуації?». Одне питання, поставлене двічі поспіль. Тепер це одна панель:
 * головне — написати чи подзвонити, а поруч, дрібніше, — де пошукати
 * відповідь самому.
 *
 * Від lg кнопки праворуч на обидва рядки, нижче — одразу під текстом, до
 * посилань: на телефоні дія важливіша за довідку.
 */
const SituationsCta = ({ className = '' }) => (
  <section
    aria-labelledby="situations-cta-title"
    className={`relative overflow-hidden rounded-2xl bg-gradient-to-r from-teal-700 to-sky-700 p-6 sm:p-8 lg:p-10 text-white shadow-md ${className}`}
  >
    <span className="absolute -top-10 -right-10 w-40 h-40 bg-white/10 rounded-full blur-3xl pointer-events-none" aria-hidden="true"></span>

    <div className="relative grid gap-6 lg:grid-cols-[minmax(0,1fr)_auto] lg:gap-x-12 lg:gap-y-7">
      <div className="lg:col-start-1 lg:row-start-1">
        <h2 id="situations-cta-title" className="text-2xl lg:text-3xl font-black font-display text-balance">
          Не знайшли своєї ситуації?
        </h2>
        <p className="mt-3 max-w-2xl text-base lg:text-lg leading-relaxed opacity-95">
          {tie('Опишіть її двома реченнями — і ми скажемо, з чого починати та що для цього знадобиться.')}
        </p>
      </div>

      <div className="flex flex-col sm:flex-row lg:flex-col gap-3 lg:col-start-2 lg:row-start-1 lg:row-span-2 lg:self-center">
        <Link
          to="/kontakty"
          onClick={() => trackEvent('cta_click', 'situations')}
          className="inline-flex items-center justify-center gap-3 rounded-lg bg-white px-6 py-3 font-bold text-teal-700 hover:bg-teal-50 transition-colors duration-200 whitespace-nowrap focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-teal-700"
        >
          Отримати консультацію
          <Icon name="fa-arrow-right" />
        </Link>
        <a
          href={PHONE.href}
          onClick={() => trackEvent('contact_channel', 'situations-phone')}
          className="inline-flex items-center justify-center gap-3 rounded-lg border border-white/60 px-6 py-3 font-bold text-white hover:bg-white/10 transition-colors duration-200 whitespace-nowrap focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-teal-700"
        >
          <Icon name="fa-phone" />
          {PHONE.label}
        </a>
      </div>

      <div className="lg:col-start-1 lg:row-start-2 border-t border-white/20 pt-4 flex flex-wrap items-center gap-x-6">
        <span className="w-full sm:w-auto py-1 text-sm text-white/90">Або спершу подивіться:</span>
        <Link
          to="/pytannya"
          className="group inline-flex items-center gap-2 py-2.5 font-semibold underline decoration-white/40 underline-offset-4 hover:decoration-white transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm"
        >
          Часті запитання
          <Icon name="fa-arrow-right" className="text-xs transition-transform duration-200 group-hover:translate-x-0.5" />
        </Link>
        <Link
          to="/poslugy"
          className="group inline-flex items-center gap-2 py-2.5 font-semibold underline decoration-white/40 underline-offset-4 hover:decoration-white transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm"
        >
          Перелік напрямків
          <Icon name="fa-arrow-right" className="text-xs transition-transform duration-200 group-hover:translate-x-0.5" />
        </Link>
      </div>
    </div>
  </section>
);

export default SituationsCta;
